<section [class.docuty-card]="variant === 'card'" class="get-app">
  <header *ngIf="variant === 'card'" class="docuty-card-header">
    <h2 class="docuty-card-title">
      <mat-icon>smartphone</mat-icon>
      {{ 'GET_APP.TITLE' | translate }}
    </h2>
  </header>

  <p class="get-app-text">{{ 'GET_APP.TEXT' | translate }}</p>
  <p class="get-app-hint">{{ 'GET_APP.LOGIN_HINT' | translate }}</p>

  <div class="get-app-stores">
    <!-- Phone: exactly one store, shown as the primary action. -->
    <ng-container *ngIf="platform === 'ios'">
      <a mat-flat-button color="accent" [href]="appStoreUrl" target="_blank" rel="noopener">
        <mat-icon>phone_iphone</mat-icon>
        {{ 'GET_APP.APP_STORE' | translate }}
      </a>
    </ng-container>
    <ng-container *ngIf="platform === 'android'">
      <a mat-flat-button color="accent" [href]="playStoreUrl" target="_blank" rel="noopener">
        <mat-icon>android</mat-icon>
        {{ 'GET_APP.PLAY_STORE' | translate }}
      </a>
    </ng-container>
    <!-- Desktop: both stores side by side, neither is the single primary. -->
    <ng-container *ngIf="platform === 'other'">
      <a mat-stroked-button [href]="appStoreUrl" target="_blank" rel="noopener">
        <mat-icon>phone_iphone</mat-icon>
        {{ 'GET_APP.APP_STORE' | translate }}
      </a>
      <a mat-stroked-button [href]="playStoreUrl" target="_blank" rel="noopener">
        <mat-icon>android</mat-icon>
        {{ 'GET_APP.PLAY_STORE' | translate }}
      </a>
    </ng-container>
  </div>
</section>
